import { Form, Input, Button } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

export default function FormItemList({
  label,
  name,
}: {
  label: string;
  name: string;
}) {
  return (
    <Form.Item label={label} className="no-margin-bottom">
      <Form.List name={name}>
        {(fields, { add, remove }, { errors }) => (
          <>{fields.map(({ key, name, ...restField }) => (
            <div key={key} style={{ display: 'flex', gap: 8, marginBottom: 8, height: 32 }}>
              <Form.Item
                {...restField}
                name={name}
                style={{ width: "100%" }}
              >
                <Input />
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'rgba(0, 0, 0, 0.45)', }} />
            </div>
          ))}
            {errors.length > 0 && (
              <Form.Item>
                <Form.ErrorList errors={errors} />
              </Form.Item>
            )}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<PlusOutlined />}
              >
                Add Row
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
}
